import select from './DepartmentUserSelect.vue'
const DepartmentUserSelect = {
	install: function(Vue) {
		Vue.component('DepartmentUserSelect', select)
	}
}
export default DepartmentUserSelect
